import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHeartFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "e/icon/shape/heart_fill",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M10.987 20.4659L11.4237 20.8037C11.5897 20.931 11.7917 21 11.9995 21C12.208 21 12.41 20.931 12.576 20.8037L13.0127 20.4659C17.6333 16.9037 21.9998 13.538 21.9998 8.83763C21.9998 7.65717 21.6473 6.50503 20.9906 5.53242C20.3339 4.5591 19.4024 3.81207 18.3195 3.38871C17.2367 2.96528 16.0534 2.88541 14.9248 3.16078C13.797 3.43531 12.7763 4.05091 11.9993 4.92772C11.2224 4.05091 10.2026 3.43531 9.07394 3.16078C7.94618 2.88541 6.76197 2.96528 5.67915 3.38871C4.59636 3.81215 3.66487 4.55919 3.00812 5.53242C2.35142 6.5049 1.99976 7.65708 1.99976 8.83763C1.99976 13.5378 6.36619 16.9028 10.987 20.4659Z"
		})
	})
});
export default SvgHeartFill;
